import Api from '@api/decoration'
import TeamApi from '@api/team'
import MainStore from '@components/Main/store'
import {
  NEW_THEME_CONFIG,
  STATISTIC_DECORATION_EDIT,
  THEME_BLACK_GOLD,
  THEME_COLOR,
  THEME_TOP_WEDDING,
  THEME_WHITE_RED
} from '@constant'
import { dGet } from '@core/utils'
import { isUltimate, isWeddingDressPhotoProperty } from '@merchant-backend/util'
import { getMerchantInfo, getProTitle, isSiDaTeam, pro, statistic } from '@util'
import { message, Modal } from 'hljd'
import { action, computed, observable } from 'mobx'
import { hashHistory } from 'react-router'
import {
  getDecorationModules,
  getHomeCaseCount,
  getHomeMealCount
} from '../../util'
import GroupCoverStore from './groupCoverStore'
import SiYiGroupStyleStore from './siYiGroupStyleStore'

class Store {
  @observable homeData = {}
  @observable videoData = {}
  @observable videosData = []
  @observable activityData = {}
  @observable promiseData = {}
  @observable liveData = {}
  @observable theme
  @observable adminModule = 0 // 旗舰版模块
  @observable currentEditting = '' // 当前正在编辑的模块
  @observable meal = {}
  @observable teamMeal = {} // 团购套餐
  @observable example = {}
  @observable mealPropertyList = [] // 套餐类目
  @observable casePropertyList = [] // 案例类目
  @observable recommendWindow = {}

  @observable qa = {}
  @observable easyChat = ''
  @observable allStatus = {}
  @observable currentCaseProperty = '' // 当前案例（作品）类目，默认全部
  @observable urlEditting = '' // URL传currentEditting值 当前选中类型
  @observable casePropertyTagList = []
  @observable brand = []
  @observable ringSeriesList = [] // 婚戒系列
  @observable merchantHomeData = {} // 主页总接口

  @observable otherGuide = false // 切换右侧引导栏显示，false 新手指南，true 其他课程指南

  @observable iframeShowAreaRef // iframe 展示h5区域 ref实例

  /**
   * @title 向iframe窗口发送消息
   * @param {object} params 需要向iframe发送的参数
   * @param {string} origin 发送的目标源url
   */
  @action
  sendMessage = (params, origin = '*') => {
    this.iframeShowAreaRef &&
      this.iframeShowAreaRef.contentWindow.postMessage(params, origin)
  }

  /**
   * showAll：是否展示所有模块；只有当 url 传 type=all 时才会显示全部
   */
  constructor({ mode = 'editable', theme = THEME_WHITE_RED, showAll } = {}) {
    this.mode = mode

    const isAll = showAll === 'all'

    const isTopWedding = !!+getMerchantInfo().top_wedding

    // 非旗舰版，当作预览非完整版时，主题为默认色
    this.theme = isTopWedding
      ? THEME_TOP_WEDDING
      : isUltimate()
        ? theme
        : mode === 'preview' && !isAll
          ? THEME_WHITE_RED
          : theme
    // 显示所有模块
    this.showAll = isAll
    this.decorationModules = getDecorationModules()
    // TOOD，有这个模块才new
    this.groupCoverStore = new GroupCoverStore(this)
    this.siYiGroupStyleStore = new SiYiGroupStyleStore(this)
  }

  /**
   * 改变otherGuide
   */
  changeOtherGuide = val => (this.otherGuide = val)

  setStoreData = params => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })
  }

  /**
   * 旗舰版获取主题色
   */
  getTheme = async () => {
    const {
      data: { theme }
    } = await Api.getTheme({
      merchant_id: getMerchantInfo().id,
      full_edition: 1
    })
    this.theme = theme || THEME_WHITE_RED
  }

  /**
   * 保存主题
   */
  setTheme = key => {
    Modal.confirm({
      title: '确认修改主题色',
      content: '修改完成后，App和小程序的商家主页都将同步变更。',
      onOk: async () => {
        const { success } = await Api.setTheme({ id: key })

        if (success) {
          this.theme = key
          message.success('设置成功')
          // 更新旗舰版模块数
          this.getProSettingItem()
        } else {
          message.warn('设置失败')
        }
      }
    })
  }

  /**
   * 获取非旗舰版设置的旗舰版模块数
   */
  getProSettingItem = async () => {
    if (!isUltimate()) {
      const {
        data: { count }
      } = await Api.getProItem()
      this.adminModule = count || 0
    }
  }

  @pro({
    content: `该主题色为${getProTitle()}专属功能, 如需将该模块展示给用户，请尽快开通${getProTitle()}。`,
    shouldBreak: false
  })
  @action
  changeTheme(key) {
    // 旗舰版保存主题
    // if (isUltimate()) {
    this.setTheme(key)
    // }
  }

  changeCurrentEditting = key => {
    statistic(STATISTIC_DECORATION_EDIT)
    this.currentEditting = key
    hashHistory.push({
      pathname: '/localMerchant/decoration',
      query: {
        type: key
      }
    })
    this.changeOtherGuide(false)
    this.handleEditAreaPosition()
  }

  /**
   * 右侧编辑区域高度计算
   */
  handleEditAreaPosition = () => {
    const el = document.querySelector('#decoration-edit')
    const val = MainStore.contentMainDiv.current.scrollTop
    el.style.marginTop = val > 80 ? `${val - 80}px` : 0
  }

  getHomeData = async () => {
    this.getMerchantData()
    this.getOtherData()
    this.getProSettingItem()
    // 婚戒首饰获取列表
    if (getMerchantInfo().property_id == 14 || 1) {
      this.getRingSeriesList()
    }
  }

  getRingSeriesList = async () => {
    const {
      data: { list },
      success
    } = await Api.getSeriesList({ per_page: 6 })
    if (success) {
      this.ringSeriesList = list
    }
  }

  getMerchantData = async () => {
    const { data } = await Api.getHomeData({
      client_type: 'merchant',
      full_edition: 1,
      mer_id: getMerchantInfo().id
    })

    this.homeData = data || {}
  }

  /**
   * http://autotest.hunliji.com/web/#/home/project/api/edit?projectId=-701335349&apiId=204091&moduleid=2453
   */
  getOtherData = async () => {
    const { data } = await Api.getMerchantHomeData({
      client_type: 'merchant',
      full_edition: 1,
      merchant_id: getMerchantInfo().id
    })

    this.merchantHomeData = data || {}
    this.videoData = dGet(data, 'merchant_video', {}) || {}
    // 三大团队封面视频
    this.videosData = dGet(data, 'merchant_videos', []) || []
    this.activityData = dGet(data, 'merchant_activity', {}) || {}
    this.promiseData = dGet(data, 'merchant', {}) || {}
    this.liveData = dGet(data, 'live', {}) || {}
    this.brand = dGet(data, 'brand', []) || []
  }

  updateHome = () => {
    this.getAllStatus()
    this.getHomeData()
  }

  /**
   * 获取审核状态
   */
  getAllStatus = async () => {
    const { data } = await Api.allStatus()
    this.allStatus = data || {}
  }

  /**
   * 推荐橱窗
   */
  getWindowList = async () => {
    const { data } = await Api.showCaseListApi({
      full_edition: 1
    })

    this.recommendWindow = data || {}
  }

  /**
   * 获取款式相册列表
   */
  getStyleAlbumList = async () => {
    const { data } = await Api.styleManageList({
      full_edition: 1
    })

    this.styleAlbum = data || {}
  }

  /**
   * 套餐案例类目列表（commodity_type 0套餐 1案例）
   */
  getMealCaseProperty = async params => {
    const {
      data: { list }
    } = await Api.mealCaseProperty({
      ...params,
      merchant_id: getMerchantInfo().id
    })

    if (params.commodity_type == 0) {
      this.mealPropertyList = list || []
    } else {
      this.casePropertyList = list || []
    }
  }

  /**
   * 套餐案例类目列表（婚纱摄影）
   */
  getMealCasePropertyList = async () => {
    const {
      data: { category_list }
    } = await Api.mealCasePropertyV2({
      merchant_id: getMerchantInfo().id
    })

    this.casePropertyTagList = category_list || []
  }

  /**
   * 切换作品类目（加盟店）
   */
  @action
  changeCaseProperty = id => {
    this.currentCaseProperty = id
    this.getCaseList()
  }

  /**
   * 店铺首页套餐、团购套餐
   */
  getMealList = async (params = {}) => {
    const p = {
      per_page: getHomeMealCount(),
      commodity_type: 0
    }

    // /p/wedding/index.php/home/APISetMeal/list 需传id
    if (!isSiDaTeam()) {
      p.id = getMerchantInfo().id
    }

    const { data } = await Api.mealCaseList({
      ...p,
      ...params
    })
    const res = data || {}

    if (params.hot_tag == 4) {
      this.teamMeal = res
    } else {
      this.meal = res
    }
  }

  /**
   * 案例（作品）列表
   */
  getCaseList = async () => {
    const params = {
      per_page: getHomeCaseCount(),
      merchant_id: getMerchantInfo().id,
      commodity_type: 1,
      status: 1,
      property_id: 0,
      is_sold_out: 0
    }

    if (isWeddingDressPhotoProperty()) {
      params.category_id = this.currentCaseProperty
    }

    const { data } = await Api.mealList(params)

    this.example = data || {}
  }

  /**
   * 问大家
   */
  getQaList = async () => {
    const { data } = await Api.qaList({
      merchant_id: getMerchantInfo().id
    })

    this.qa = data || {}
  }

  /**
   * 轻松聊
   */
  getEasyChat = async () => {
    const { data } = await Api.adminEasyChat()

    this.easyChat = data || {}
  }

  @computed
  get themeConfig() {
    return THEME_COLOR[this.theme]
  }

  @computed
  get newThemeConfig() {
    return NEW_THEME_CONFIG[this.theme]
  }

  @computed
  get isThemeBlackGold() {
    return this.theme == THEME_BLACK_GOLD || this.theme == THEME_TOP_WEDDING
  }

  @observable real_photos = []

  getRealPhotos = async () => {
    const {
      data: { list }
    } = await TeamApi.getRealPhoto()
    this.real_photos = list || []
  }

  setUrlEditting = type => {
    this.urlEditting = type
    this.currentEditting = type
    // this.handleEditAreaPosition()
  }
}

export default Store
